import { Box } from "@mui/material";
import { useTheme as useRaTheme } from "react-admin";
import { useTheme } from "@emotion/react";

export const Spacer = ({ x, y, children, ...rest }) => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                display: "flex",
                width: x ? theme.spacing(x) : undefined,
                height: y ? theme.spacing(y) : undefined
            }}>
            {children}
        </Box>
    );
};

// MUI v9 removed system props from Box, so style props passed to Container
// (e.g. display, alignItems, textAlign) must be moved into `sx` explicitly.
const SX_PROPS = new Set([
    "display", "flexDirection", "flexWrap", "flexGrow", "flexShrink", "flex",
    "alignItems", "alignContent", "alignSelf", "justifyContent", "gap",
    "textAlign", "color", "position", "top", "right", "bottom", "left",
    "width", "height", "minWidth", "maxWidth", "minHeight", "maxHeight",
    "overflow", "m", "mx", "my", "p", "px", "py",
]);

export const Container = ({ ml, mr, mt, mb, pl, pr, pt, pb, sx, children, ...rest }) => {
    const theme = useTheme();
    const styleProps = {};
    const boxProps = {};
    Object.entries(rest).forEach(([key, value]) => {
        (SX_PROPS.has(key) ? styleProps : boxProps)[key] = value;
    });
    return (
        <Box
            {...boxProps}
            sx={[
                styleProps,
                {
                    marginLeft: ml && theme.spacing(ml),
                    marginRight: mr && theme.spacing(mr),
                    marginTop: mt && theme.spacing(mt),
                    marginBottom: mb && theme.spacing(mb),
                    paddingLeft: pl && theme.spacing(pl),
                    paddingRight: pr && theme.spacing(pr),
                    paddingTop: pt && theme.spacing(pt),
                    paddingBottom: pb && theme.spacing(pb),
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
        >
            {children}
        </Box>
    );
};

export const ButtonContainer = ({ children, flexDirection, display }) => {
    const [theme, setTheme] = useRaTheme();

    return (
        <Container sx={{width: "100%", paddingTop: 12}}>
            <Container
                display={display && display}
                flexDirection={flexDirection && flexDirection}
                sx={{
                    width: "100%",
                    position: "fixed",
                    bottom: 0,
                    margin: "auto auto",
                    left: 0,
                    right: 0,
                    backgroundColor: theme === "dark" ? "#313131" : "#fafafb",
                    zIndex: 2,
                }}
                pl={2}
                pr={2}
                pt={2}
                pb={2}
            >
                {children}
            </Container>
        </Container>
    );
};
